import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const SiteMediaContext = createContext({
  logoUrl: null,
  portraitUrl: null,
  gallery: [],
  refresh: () => {},
});

/**
 * Loads the owner-uploaded media (logo / portrait / gallery).
 * Refetches on every route change so an upload in /admin is visible
 * immediately when navigating — no manual page refresh needed.
 * NOTE: must be rendered INSIDE BrowserRouter (uses useLocation).
 */
export const SiteMediaProvider = ({ children }) => {
  const [media, setMedia] = useState({ logoUrl: null, portraitUrl: null, gallery: [] });
  const { pathname } = useLocation();

  const refresh = useCallback(() => {
    fetch(`${BACKEND_URL}/api/media/slots`, { cache: "no-store" })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (!d) return;
        setMedia({
          logoUrl: d.logo ? BACKEND_URL + d.logo.url : null,
          portraitUrl: d.portrait ? BACKEND_URL + d.portrait.url : null,
          gallery: (d.gallery || []).map((g) => ({ ...g, url: BACKEND_URL + g.url })),
        });
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh, pathname]);

  return (
    <SiteMediaContext.Provider value={{ ...media, refresh }}>
      {children}
    </SiteMediaContext.Provider>
  );
};

export const useSiteMedia = () => useContext(SiteMediaContext);
